import { render } from "./admin-company-workspace.vue?vue&type=template&id=46ab722b"
import script from "./admin-company-workspace.vue?vue&type=script&lang=js"
export * from "./admin-company-workspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-company-workspace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46ab722b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46ab722b', __exports__)) {
    api.reload('46ab722b', __exports__)
  }
  
  module.hot.accept("./admin-company-workspace.vue?vue&type=template&id=46ab722b", () => {
    api.rerender('46ab722b', render)
  })

}


export default __exports__